const comments = [
  {
    name: '追剧小达人',
    avatar: 'Z',
    rating: 5,
    text: '向日葵视频真的太香了！不用注册就能看，画质还特别清晰。榴莲视频上的热门剧这里全都有，更新速度也快，每天晚上追星辰大海完全不卡顿，强烈推荐！',
    date: '2天前',
  },
  {
    name: '电影爱好者',
    avatar: 'D',
    rating: 5,
    text: '找了好久终于在向日葵视频找到了红杏视频的《长安夜未央》全集，4K画质太震撼了！古装剧的服化道细节看得一清二楚，而且免费看真的太良心了。',
    date: '3天前',
  },
  {
    name: '综艺控一枚',
    avatar: 'Z',
    rating: 5,
    text: '每周必看的《欢乐集结号》这里更新最快！之前在其他平台等好久都看不到最新期，向日葵视频基本同步上线。手机上看也特别流畅，通勤路上追综艺太爽了。',
    date: '4天前',
  },
  {
    name: '悬疑剧迷',
    avatar: 'X',
    rating: 4,
    text: '《迷雾追踪》第二季全网首更就是在向日葵视频看到的！烧脑剧情看得我停不下来，画质流畅度都很棒。唯一的建议是希望增加倍速播放功能，有些片段想跳着看。',
    date: '5天前',
  },
  {
    name: '动漫二次元',
    avatar: 'E',
    rating: 5,
    text: '国漫专区做得太好了！星辰变、完美世界、斗罗大陆全都有，画质高清不缓冲。向日葵视频真的是国漫迷的天堂，每天蹲更新已经成为我的日常了哈哈。',
    date: '6天前',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            用户心声
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            用户评价
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            听听向日葵视频的用户们怎么说，真实反馈见证品质
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className="p-5 rounded-xl bg-background-50 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100/80 flex items-center justify-center text-primary-700 font-bold text-sm">
                  {item.avatar}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-400">{item.date}</div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-2">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${
                      i < item.rating
                        ? 'ri-star-fill text-secondary-500'
                        : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}